import { get } from "@/api/request"

export const sessionDetail = params => get("/v1/session/detail", params)//拍卖会详情
export const getApp = params => get("https://sapi.artron.net/api/agent/source", params)//拍卖会详情


